/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObjectUtils from './MoserObjectUtils';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForLocalRef
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * Local reference must only reference to the query items within the same query subject <p>Java class for localRefType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="localRefType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class LocalRefType extends ObjectType{

	ref = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(6, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForLocalRef(this.getParent());
		this._referencedObject = null;
	}

	/**
	 * Creates a new instance of <code>LocalRefType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> LocalRefType</code> object from.
	 * @return {LocalRefType} an object of type <code>LocalRefType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createLocalRefType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "LocalRefType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 6, "ref", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 6:
			this.setRef((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/LocalRefType.js